import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Navigation from '@rocketseat/gatsby-theme-docs/src/components/Docs/PostNav';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "react-observing",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#react-observing",
        "aria-label": "react observing permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`React observing`}</h1>
    <p>{`React observing is a performance-focused library for state management in React.
Using hooks and state builders, you can build a complex state management.
Keeping your app really fast, this library re-render only a component that need a re-render.`}</p>
    <h2 {...{
      "id": "build-a-observable-state",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#build-a-observable-state",
        "aria-label": "build a observable state permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Build a observable state`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const Store = observe('value')
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const Store = {
  prop1: observe('value'),
  prop2: observe('value'),
}
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const Store = observe({
  prop1: observe('value'),
  prop2: observe('value'),
})
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const Store = observe([
  observe('value'),
])
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`To work correctly all properties that are States must be mandatory. `}<a parentName="p" {...{
          "href": "/more/mandatory-properties"
        }}>{`See more`}</a></p>
    </blockquote>
    <h2 {...{
      "id": "hooks",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#hooks",
        "aria-label": "hooks permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Hooks`}</h2>
    <p>{`Use one of our hooks to listen for any value changes that happen to your observable.`}</p>
    <h3 {...{
      "id": "useobserver",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#useobserver",
        "aria-label": "useobserver permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><inlineCode parentName="h3">{`useObserver`}</inlineCode></h3>
    <p>{`Returns a react state and set state from a observable object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const [value, setValue] = useObserver(myObservable)
`}</code></pre>
    <h3 {...{
      "id": "useobservervalue",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#useobservervalue",
        "aria-label": "useobservervalue permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><inlineCode parentName="h3">{`useObserverValue`}</inlineCode></h3>
    <p>{`Returns a react state from a observable object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const value = useObserverValue(myObservable)
`}</code></pre>
    <h3 {...{
      "id": "usesetobserver",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#usesetobserver",
        "aria-label": "usesetobserver permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a><inlineCode parentName="h3">{`useSetObserver`}</inlineCode></h3>
    <p>{`Returns a react set state from a observable object.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`const setValue = useSetObserver(myObservable)
`}</code></pre>
    <h2 {...{
      "id": "each-property-as-state",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#each-property-as-state",
        "aria-label": "each property as state permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Each property as state`}</h2>
    <p>{`You can have properties that are states and properties that are not states.
You can do what you want.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`people # State
-- id # State
-- age # State
-- name # State
-- more # State
---- middleName # State
---- lastName # State
`}</code></pre>
    <p>{`Or`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`people # State
-- id # State
-- age # State
-- name # State
-- more # NOT a state
---- middleName # State
---- lastName # NOT a state
`}</code></pre>
    <h2 {...{
      "id": "array-of-states",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#array-of-states",
        "aria-label": "array of states permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Array of states`}</h2>
    <p>{`Each state can be updated separately without interfering with the others.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-yaml"
      }}>{`peoples # State
-- [0]
---- name # State
-- [1]
---- name # State
-- [2]
---- name # State
`}</code></pre>
    <Navigation prev={null} next={{
      label: 'Installation',
      link: '/installation'
    }} mdxType="Navigation" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      